module.exports = __webpack_public_path__ + "static/media/smileRating3Active.ab2b1bc3.svg";